module.exports = __webpack_public_path__ + "static/media/flutter_logo.fdb46fc7.svg";